import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import TaskSkeleton from "./TaskSkeleton";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { canEdit } from "../utils/permissions";

export default function Hq() {
  const navigate = useNavigate();
  const { http, user } = AuthUser();
  const allowEdit = canEdit(user);
  const [tasks, setTasks] = useState([]);
  const [tasksind, setTasksInd] = useState([]);
  const [TaskCount, setTaskCount] = useState();
  const [TotalCount, setTotalCount] = useState();
  const [date, setDate] = useState(null);
  const [remark, setRemark] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [loginUserId, setloginUserId] = useState(user.id);
  const [selectedDepartmentId, setselectedDepartmentId] = useState("");
  const [selectedStatus, setsselectedStatus] = useState("hq");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [editColumn, setEditColumn] = useState(null);
  const [users, setUsers] = useState([]);
  const [editUser, setEditUser] = useState({});
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [descriptionToView, setDescriptionToView] = useState("");

  useEffect(() => {
    http.get(`/department_user_company?&login_user=${user.id}`).then((res) => {
      setUsers(res.data.users);
    });
    fetchTaskDetails(selectedDepartmentId, selectedStatus, startDate, endDate);
  }, [selectedDepartmentId, selectedStatus, startDate, endDate]);

  const fetchTaskDetails = (
    seldepartment = "",
    selstatus = "",
    startDate = "",
    endDate = ""
  ) => {
    setIsLoading(true);
    let endpoint;
    if (user && user.department_id === 1) {
      endpoint = `/tasks_job?department=${seldepartment}&status=${selstatus}&login_user=${user.id}&startdate=${startDate}&enddate=${endDate}`;
    } else if (user) {
      endpoint = `/tasks_job?user=${user.id}&department=${seldepartment}&status=${selstatus}&login_user=${user.id}&startdate=${startDate}&enddate=${endDate}`;
    } else {
      setIsLoading(false);
      console.error("User is not defined or authenticated");
      return;
    }

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
          setTaskCount(res.data.data.length);
          setTotalCount(res.data.total_count);
        } else {
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });

    http.get(`/branch`).then((res) => {
      setdepartments(res.data.users);
    });
  };

  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [showModalRevise, setShowModalRevise] = useState(false);

  const openModal = async (taskId) => {
    setShowModal(true);
    await http
      .get(`/tasks_job_ind?id=${taskId}`)
      .then((res) => {
        setTasksInd(res.data.data);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });
  };

  const openModalRevise = (rmark, revisedate) => {
    setDate(revisedate);
    setRemark(rmark);
    setShowModalRevise(true);
  };

  const handleChange = async (event) => {
    setselectedDepartmentId(event.target.value);
  };

  const handleChangeType = async (event) => {
    setsselectedStatus(event.target.value);
  };

  const handleChangeStartDate = async (event) => {
    setstartDate(event.target.value);
  };

  const handleChangeEndDate = async (event) => {
    setendDate(event.target.value);
  };

  const statusUpdate = (e) => {
    setCurrentStatus(e.target.value);
  };

  const deleteTask = async (taskId) => {
    await http
      .delete(`/tasks_jc/${taskId}`)
      .then((response) => {
        toast.success("Task Deleted successfully !");
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const sendConfirm = async (userId, id) => {
    await http
      .post(`/send_confirm_jc/${userId}/${id}`)
      .then((response) => {
        toast.success("Confirmation Email/SMS sent");
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
      })
      .catch((err) => {
        console.error("Error sending email", err);
      });
  };

  const handleSave = async (taskId) => {
    if (currentStatus === null || taskId === null) {
      toast.error("Please select proper status");
      return true;
    }
    try {
      await http.put(
        `task_status_update_jc?task_id=${taskId}&status=${encodeURIComponent(
          currentStatus
        )}`
      );
      toast.success("Task status updated successfully !");
      fetchTaskDetails(selectedDepartmentId, selectedStatus);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Please select proper item");
    }
  };

  const [formData1, setFormData1] = useState({
    assigned_to: "",
    assiger_branch: "",
    est_time: "",
    service_amount: "",
  });

  const handleChangeModal = (e) => {
    setFormData1({
      ...formData1,
      [e.target.name]: e.target.value,
    });
  };

  function getRandomLightColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  const backgroundColorMap = new Map();

  function getUniqueBackgroundColor(userId) {
    if (!backgroundColorMap.has(userId)) {
      backgroundColorMap.set(userId, getRandomLightColor());
    }
    return backgroundColorMap.get(userId);
  }

  const openEditModal = async (taskAll, index) => {
    setEditColumn(index);
    setShowModal1(true);
    setFormData1({
      assigned_to: taskAll.assigned_to || "",
      assiger_branch: taskAll.assiger_branch || "",
      est_time: taskAll.est_time || "",
      service_amount: taskAll.service_amount || "",
    });
    setEditUser(taskAll);
  };

  const saveEditedCustemer = async (e) => {
    e.preventDefault();
    try {
      if (!editUser) {
        console.error("No user data to edit.");
        return;
      }

      const response = await http.put(`/jc_edit/${editUser.id}`, formData1);
      if (Array.isArray(response.data.data)) {
        toast.success("Data updated successfully!");
        setShowModal1(false);
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
      } else {
        console.log("API response is not an array");
      }
    } catch (error) {
      console.error("Error updating user", error);
      toast.error("An error occurred while updating the customer.");
    }
    setEditColumn("");
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModal1(false);
    setEditColumn("");
  };

  const openIndividualPrint = (id) => {
    navigate(`/jobcart/print/${id}`);
  };

  const handlePrintAll = () => {
    if (!tasks.length) {
      toast.error("No tasks to print");
      return;
    }
    window.print();
  };

  const handleExcel = () => {
    if (!tasks.length) {
      toast.error("No tasks to export");
      return;
    }
    const rows = tasks.map((t, i) => ({
      No: i + 1,
      ID: `JC${t.id}`,
      Created: t.created_at ? moment(t.created_at).format("DD MMM,YY hh:mm A") : "",
      Branch: t.branch?.branch_name || "",
      Description: t.description || "",
      Company: t.customer?.company || "",
      Name: t.customer?.name || "",
      Status: t.status || "",
      "Del Date": t.target_date ? moment(t.target_date).format("DD MMM,YY") : "",
      Est: t.est_time ?? "",
      Price: t.service_amount ?? "",
      "Assign By": [t.assigner?.name, t.assigner?.last_name].filter(Boolean).join(" "),
      "Assign To": [t.assignee?.name, t.assignee?.last_name].filter(Boolean).join(" "),
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "HQ Tasks");
    XLSX.writeFile(wb, `hq_tasks_${moment().format("YYYYMMDD_HHmm")}.xlsx`);
  };

  const openDescriptionModal = (description) => {
    setDescriptionToView(description || "");
    setShowDescriptionModal(true);
  };

  const copyDescription = async (description) => {
    try {
      await navigator.clipboard.writeText(description || "");
      toast.success("Description copied");
    } catch (err) {
      toast.error("Failed to copy");
    }
  };

  const renderStatus = (status) => {
    if (status === "Delivered")
      return <span className="badge bg-success font-size-13">Delivered</span>;
    if (status === "Pending")
      return <span className="badge bg-warning font-size-13">Pending</span>;
    if (status === "Hold-In-HQ")
      return <span className="badge bg-danger font-size-13">Hold-In-HQ</span>;
    if (status === "Hold-To-HQ")
      return <span className="badge bg-danger font-size-13">Hold-To-HQ</span>;
    if (status === "Ready infomed")
      return (
        <span className="badge bg-secondary font-size-13">Ready infomed</span>
      );
    if (status === "Ready returned")
      return (
        <span className="badge bg-secondary font-size-13">Ready returned</span>
      );
    return status ? (
      <span className="badge bg-secondary font-size-13">{status}</span>
    ) : (
      "—"
    );
  };

  return (
    <>
      <Toaster />

      {showDescriptionModal && (
        <div
          className="modal show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Description</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDescriptionModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div
                  className="p-3 bg-light rounded"
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    minHeight: "80px",
                  }}
                >
                  {descriptionToView || (
                    <span className="text-muted">No description</span>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => copyDescription(descriptionToView)}
                >
                  Copy
                </button>
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={() => setShowDescriptionModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && tasksind.length > 0 && (
        <div className="modal" tabIndex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Product Details: <b>#JC {tasksind[0].id}</b>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group mt-3">
                  <label>Product Name</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].product_name}
                    readOnly
                  />
                </div>
                <div className="form-group mt-3">
                  <label>Model</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].model}
                    readOnly
                  />
                </div>
                <div className="form-group mt-3">
                  <label>Brand</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].brand}
                    readOnly
                  />
                </div>
                <div className="form-group mt-3">
                  <label>Engineer Remark</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].eng_remark}
                    readOnly
                  />
                </div>
                <div className="form-group mt-3">
                  <label>Damage Remark</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].damage_remark}
                    readOnly
                  />
                </div>
                <div className="form-group mt-3">
                  <label>Battery:</label>{" "}
                  {tasksind[0].bettery === 1 ? (
                    <b className="text-danger px-1">No</b>
                  ) : (
                    <b className="text-success px-1">Yes</b>
                  )}
                  <br />
                  <label>Power adapter:</label>{" "}
                  {tasksind[0].power_adapter === 1 ? (
                    <b className="text-danger px-1">No</b>
                  ) : (
                    <b className="text-success px-1">Yes</b>
                  )}
                  <br />
                  <label>Carry case:</label>{" "}
                  {tasksind[0].carry_case === 1 ? (
                    <b className="text-danger px-1">No</b>
                  ) : (
                    <b className="text-success px-1">Yes</b>
                  )}
                  <br />
                  <label>Laptop Bag:</label>{" "}
                  {tasksind[0].laptop_bag === 1 ? (
                    <b className="text-danger px-1">No</b>
                  ) : (
                    <b className="text-success px-1">Yes</b>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal1 && (
        <form onSubmit={saveEditedCustemer}>
          <div className="modal" tabIndex="-1" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Job card</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-group mt-3">
                    <label>Assigned To</label>
                    <select
                      name="assigned_to"
                      className="form-control text-uppercase"
                      defaultValue={formData1.assigned_to}
                      onChange={handleChangeModal}
                      required
                    >
                      <option value="">Select a user</option>
                      {users.map((u) => (
                        <option key={u.id} value={u.id}>
                          {u.name} {u.last_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group mt-3">
                    <select
                      defaultValue={formData1.assiger_branch}
                      onChange={handleChangeModal}
                      name="assiger_branch"
                      className="form-control mb-1"
                      required
                    >
                      <option value="">Select Branch</option>
                      {departments.map((dept, index) => (
                        <option key={index} value={dept.id}>
                          {dept.branch_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group mt-2">
                    <label>Establish Time</label>
                    <select
                      name="est_time"
                      onChange={handleChangeModal}
                      className="form-control"
                      defaultValue={formData1.est_time}
                      required
                    >
                      <option value="0">0 Hour</option>
                      <option value="1">1 Hour</option>
                      <option value="2">2 Hour</option>
                      <option value="3">3 Hour</option>
                      <option value="4">4 Hour-Half day</option>
                      <option value="5">5 Hour</option>
                      <option value="6">6 Hour</option>
                      <option value="7">7 Hour</option>
                      <option value="8">8 Hour</option>
                    </select>
                  </div>
                  <div className="form-group mt-2">
                    <label>Service Amount</label>
                    <input
                      name="service_amount"
                      onChange={handleChangeModal}
                      defaultValue={formData1.service_amount}
                      className="form-control"
                      type="number"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      <div className="container-fluid mt-2 px-3">
        <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
          {user && user.department_id == 1 ? (
            <h4 className="mb-0 me-auto">
              All Tasks List ({TaskCount}) Total Price
              <span className="text-primary">({TotalCount})</span>
            </h4>
          ) : (
            <h4 className="mb-0 me-auto">Your Tasks List ({TaskCount})</h4>
          )}

          <select
            onChange={handleChange}
            className="form-control form-control-sm no-print"
            style={{ width: "150px" }}
          >
            <option value="">All Branch</option>
            {departments.map((dept, index) => (
              <option key={index} value={dept.id}>
                {dept.branch_name}
              </option>
            ))}
          </select>

          <select
            onChange={handleChangeType}
            className="form-control form-control-sm no-print"
            style={{ width: "140px" }}
          >
            <option value="">All Status</option>
            <option value="Hold-In-HQ">Hold-In-HQ</option>
            <option value="Hold-To-HQ">Hold-To-HQ</option>
          </select>

          <input
            name="start_date"
            onChange={handleChangeStartDate}
            className="form-control form-control-sm no-print"
            type="date"
            style={{ width: "150px" }}
          />
          <input
            name="end_date"
            onChange={handleChangeEndDate}
            className="form-control form-control-sm no-print"
            type="date"
            style={{ width: "150px" }}
          />
          <button
            type="button"
            className="btn btn-sm btn-outline-primary no-print"
            onClick={handlePrintAll}
            disabled={!tasks.length}
          >
            🖨️ Print
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-success no-print"
            onClick={handleExcel}
            disabled={!tasks.length}
          >
            ⬇ Excel
          </button>
        </div>

        <div
          className="table-responsive"
          style={{
            maxHeight: "75vh",
            overflow: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
          }}
        >
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-hover hq-table mb-0">
              <thead className="table-primary">
                <tr>
                  <th>No</th>
                  <th>ID</th>
                  <th className="text-danger">Created</th>
                  <th>Branch</th>
                  <th>Description</th>
                  <th className="print-hide">Company</th>
                  <th>Name</th>
                  <th className="contact-col">Contact</th>
                  <th>Status</th>
                  <th className="print-hide">Del Date</th>
                  <th>Est</th>
                  <th className="print-hide">Price</th>
                  <th className="print-hide">Assign By</th>
                  <th className="print-hide">Assign To</th>
                  <th className="action-column no-print">Action</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((taskuser, index) => (
                  <tr key={taskuser.id || index}>
                    <td>{index + 1}</td>
                    <td>JC{taskuser.id}</td>
                    <td className="created-cell">
                      <div>{moment(taskuser.created_at).format("DD MMM,YY")}</div>
                      <div className="text-muted" style={{ fontSize: "11px" }}>
                        {moment(taskuser.created_at).format("hh:mm A")}
                      </div>
                    </td>
                    <td>
                      <b
                        className={
                          taskuser.branch?.branch_name == "K1"
                            ? "text-danger"
                            : "text-success"
                        }
                      >
                        {taskuser.branch?.branch_name}
                      </b>
                    </td>
                    <td className="desc-cell">
                      <div className="desc-wrap">
                        <span
                          className="desc-text"
                          title={taskuser.description || ""}
                        >
                          {taskuser.description || "—"}
                        </span>
                        <span className="desc-actions">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() =>
                              openDescriptionModal(taskuser.description)
                            }
                            title="View full description"
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() =>
                              copyDescription(taskuser.description)
                            }
                            title="Copy description"
                          >
                            <i className="fas fa-copy"></i>
                          </button>
                        </span>
                      </div>
                    </td>
                    <td className="company-cell text-uppercase fw-bold print-hide" title={taskuser.customer?.company || ""}>
                      {taskuser.customer?.company}
                    </td>
                    <td className="text-uppercase fw-bold">
                      {taskuser.customer?.name}
                    </td>
                    <td className="text-nowrap contact-col">{taskuser.customer?.phone}</td>
                    <td>{renderStatus(taskuser.status)}</td>
                    <td className="text-nowrap print-hide">
                      {moment(taskuser.target_date).format("DD MMM,YY")}
                    </td>
                    <td>{taskuser.est_time}</td>
                    <td className="print-hide">{taskuser.service_amount}</td>
                    <td className="text-uppercase fw-bold text-nowrap print-hide">
                      {taskuser.assigner?.name} {taskuser.assigner?.last_name}
                    </td>
                    <td
                      className="text-uppercase fw-bold text-nowrap print-hide"
                      style={{
                        color: getUniqueBackgroundColor(taskuser.assignee?.id),
                      }}
                    >
                      {taskuser.assignee?.name} {taskuser.assignee?.last_name}
                    </td>
                    <td className="action-column">
                      <div className="action-row-1">
                        <div className="status-group">
                          <select
                            onChange={statusUpdate}
                            className="form-select-sm custom_select"
                          >
                            <option value="0">Select</option>
                            <option value="Pending">Pending</option>
                            <option value="Delivered">Delivered</option>
                            <option value="Hold-In-HQ">Hold-In-HQ</option>
                            <option value="Hold-To-HQ">Hold-To-HQ</option>
                            <option value="Ready infomed">Ready infomed</option>
                            <option value="Ready returned">
                              Ready returned
                            </option>
                          </select>
                          <button
                            className="save-btn"
                            onClick={() => handleSave(taskuser.id)}
                            title="Save Status"
                          >
                            ✓
                          </button>
                          <button
                            type="button"
                            className="action-btn"
                            title="Print job card"
                            onClick={() => openIndividualPrint(taskuser.id)}
                          >
                            🖨️
                          </button>
                          <button
                            type="button"
                            className="action-btn"
                            title="Print Name, Description, Status, Branch"
                            onClick={() =>
                              navigate(`/jobcart/print_simple/${taskuser.id}`)
                            }
                          >
                            📄
                          </button>
                        </div>
                      </div>
                      <div className="action-row-2">
                        <div className="action-buttons">
                          <button
                            className="action-btn"
                            onClick={() => openModal(taskuser.id)}
                            title="View More"
                          >
                            VM
                          </button>
                          {loginUser === 1 && allowEdit && (
                            <button
                              className="action-btn text-danger"
                              onClick={() => {
                                if (
                                  window.confirm(
                                    "Are you sure you want to delete this task?"
                                  )
                                ) {
                                  deleteTask(taskuser.id);
                                }
                              }}
                              title="Delete"
                            >
                              Del
                            </button>
                          )}
                          {loginUser === 1 && allowEdit && (
                            <button
                              className="action-btn"
                              onClick={() => openEditModal(taskuser, index)}
                              title="Edit"
                            >
                              ✏️
                            </button>
                          )}
                          <button
                            className="action-btn"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want send the emails?"
                                )
                              ) {
                                sendConfirm(
                                  taskuser.customer_id,
                                  taskuser.id
                                );
                              }
                            }}
                            title="Send Email"
                          >
                            📩
                          </button>
                          {taskuser.mail_status == 1 ? (
                            <span className="check-mark" title="Email sent">
                              ✅
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <style>{`
        .hq-table {
          font-size: 13px;
          margin-bottom: 0;
        }
        .hq-table thead th {
          position: sticky;
          top: 0;
          z-index: 2;
          white-space: nowrap;
          font-size: 12px;
          vertical-align: middle;
        }
        .hq-table td {
          vertical-align: middle;
        }
        .hq-table .created-cell {
          white-space: nowrap;
        }
        .hq-table .company-cell {
          max-width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .hq-table .desc-cell {
          min-width: 220px;
          max-width: 280px;
        }
        .hq-table .desc-wrap {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
        }
        .hq-table .desc-text {
          flex: 1 1 auto;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.4;
        }
        .hq-table .desc-actions {
          display: flex;
          align-items: center;
          gap: 4px;
          flex: 0 0 auto;
        }
        .hq-table .desc-actions .btn {
          width: 26px;
          height: 26px;
          padding: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
        }
        .hq-table .action-column {
          min-width: 170px;
        }
        .hq-table .action-row-1,
        .hq-table .action-row-2 {
          margin-bottom: 4px;
        }
        .hq-table .status-group {
          display: flex;
          flex-wrap: nowrap;
          gap: 3px;
          align-items: center;
        }
        .hq-table .action-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 3px;
          align-items: center;
        }
        .hq-table .custom_select {
          max-width: 110px;
          font-size: 11px;
          padding: 1px 4px;
          height: 22px;
        }
        .hq-table .save-btn {
          font-size: 1rem;
          padding: 0;
          width: 22px;
          height: 22px;
          background: #28a745;
          border: 1px solid #28a745;
          border-radius: 3px;
          color: white;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          line-height: 1;
        }
        .hq-table .action-btn {
          font-size: 0.7rem;
          padding: 2px 4px;
          border: 1px solid #dee2e6;
          border-radius: 3px;
          background: white;
          color: #495057;
          min-width: 22px;
          height: 22px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          text-decoration: none;
        }
        .hq-table .action-btn:hover {
          background: #f8f9fa;
        }
        .hq-table .check-mark {
          font-size: 0.7rem;
          margin-left: 2px;
        }
        @media print {
          nav, .navbar, .no-print, .desc-actions {
            display: none !important;
          }
          .contact-col,
          .print-hide {
            display: none !important;
          }
          .table-responsive {
            max-height: none !important;
            overflow: visible !important;
            border: none !important;
          }
          .hq-table .action-column {
            display: none !important;
          }
          .container-fluid {
            width: 100% !important;
            max-width: 100% !important;
            padding: 0 !important;
          }
        }
      `}</style>
    </>
  );
}
